/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="product.module.ts" />

module Meevo.Plugins.Product {

    import Variant = Meevo.Model.Variant;
    import ISearchColumn = Meevo.Model.ISearchColumn;
    import ISelectItem = Meevo.Model.ISelectItem;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;

    // todo: dev
    interface AdvancedSearchFilter {
        productsubcategory?: Object;
        distributor?: Object;
        manufacturer?: Object;
        variantObjectState?: Array<number>;
        includeActive?: boolean;
        includeActiveVariant?: boolean;
        includeDeleted?: boolean;
        isDiscontinued?: boolean;
        NotForSale?: boolean;
        productInventoryType?: ProductInventoryTypeEnum;
        floorLocation?: any;
        floorId?: string;
    }

    class ProductController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        static $inject = ["meevo.AppSettings", "meevo.components.common.DataService",
            "meevo.components.modal.ModalService", "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService", "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope", "$scope", "$state", "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService", "$translate", "$timeout", '$q',
            "meevo.components.common.ReportRouterService", "$filter"];

        public userChangedNotForSaleCheckbox: boolean;
        public isVariantsShown: boolean = true;
        public items: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public advancedSearchFilter: AdvancedSearchFilter = this.getDefaultAdvancedFilters();
        public IsFloorLocationModuleAvailable: boolean;
        
        private _productColumnsSettings: Array<ISearchColumn> = [
            { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 35 },
            { header: "Located At", fieldName: 'AtLocationName', sortDirection: null, width: 35 },
            { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 15 }
        ];
        private _productVariantColumnsSettings: Array<ISearchColumn> = [
            { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 25 },
            { header: "Located At", fieldName: 'AtLocationName', sortDirection: null, width: 20 },
            { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 10 },
            { header: "Exist At", fieldName: 'TotalLocations, AvailableAtLocations', sortDirection: null, width: 15 },
            { header: "Not For Sale", fieldName: 'notForSale', sortDirection: null, width: 15 },
            { header: "Discontinued", fieldName: null, sortDirection: null, width: 15 }
           
        ];
        public coColumnsCustom: Array<ISearchColumn> = this._productVariantColumnsSettings;
        public displayNameColumnsCustom: ISearchColumn = {
            header: "Display Name",
            fieldName: 'DisplayName',
            sortDirection: null,
            width: 20
        };

        public inventoryOptions: ISelectItem<ProductInventoryTypeEnum>[] = [
            {label: 'LABEL_SHOW_ALL', value: null},
            {label: 'LABEL_SHOW_RETAIL_ONLY', value: ProductInventoryTypeEnum.Retail},
            {label: 'LABEL_SHOW_SHOP_SUPPLY_ONLY', value: ProductInventoryTypeEnum.ShopSupply},
            {label: 'LABEL_SHOW_SHOP_RETAIL_SUPPLY_ONLY', value: ProductInventoryTypeEnum.RetailOrShopSupply},
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $q: angular.IQService,
            protected reportRouterService: Meevo.Components.Common.ReportRouterService,
            protected $filter: angular.IFilterService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService, {
                use: true,
                udfNoun: Meevo.Model.NounEnum.ProductUDF,
                appAreaEnum: Meevo.Model.AppAreaEnum.Product
            });
            if (this.identityService.inCentralOfficeMode()) {
                this.coColumnsCustom = this.isVariantsShown ? this._productVariantColumnsSettings : this._productColumnsSettings;
                this.displayNameColumnsCustom.width = this.isVariantsShown ? 30 : 20;
            }

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.product) {
                    this.processContextParams(params);
                }
            });

            if (contextParams.params) {
                this.$timeout(() => {
                    this.processContextParams(contextParams.params);
                });
            }

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.DATA_PRODUCT_VARIANT_FIELD_FLOORLOCATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.IsFloorLocationModuleAvailable = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
        }

        processContextParams(params: any): void {
            var context = <ProductContext>this.context;
            this.selectedItemId = params.selectedItemId || params.id;
            if ((this.selectedItemId != undefined || (this.contextParams.params && this.contextParams.params.selectedItemId))) {
                this.createContext();
            }
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.DATA_PRODUCT).then(() => {
                this.busyService.stop();
                this.context = new ProductContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.customDataContextConfig, this.busyService, this.$translate, this.$q, this.reportRouterService, this.$rootScope, this.$filter);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                this.busyService.stop();
            }).finally(() => {
                this.$timeout(() => {
                    this.bindHotkeys();
                });
            });
        }

        /*get securityController() {
            return new Meevo.Components.BaseClasses.DataMaintenanceSecurityController(this.$rootScope, this.securityService, this.meevoSecurityKeys.DATA_PRODUCTCATEGORY_TAB_MAIN);
        }*/

        /**
         * User toggle view product/productVariant
         * @param criteria
         * @param rootCriteria
         * @param searchCallback
         */
        searchViewChanged(criteria: AdvancedSearchFilter, rootCriteria: AdvancedSearchFilter, searchCallback: Function): void {
            if (this.identityService.inCentralOfficeMode()) {
                this.coColumnsCustom = this.isVariantsShown ? this._productVariantColumnsSettings : this._productColumnsSettings;
                this.displayNameColumnsCustom.width = this.isVariantsShown ? 30 : 20;
            }

            this.preSearch(criteria, rootCriteria, searchCallback);
        }

        /**
         * Function which calls before search function from Infinity Paging.
         * API for getting products and product-variants is different. Therefore we need to do these manimulations
         * @param criteria
         * @param rootCriteria
         * @param searchCallback
         */
        preSearch(criteria: AdvancedSearchFilter, rootCriteria: AdvancedSearchFilter, searchCallback: Function): void {
            let removeFromCriteria = this.isVariantsShown ? rootCriteria : criteria,
                addToCriteria = this.isVariantsShown ? criteria : rootCriteria;

            this.items.changeEndpoint(this.isVariantsShown ? 'productvariant' : this.appSettings.API_ENDPOINTS.product);

            delete removeFromCriteria.distributor;
            delete removeFromCriteria.manufacturer;
            delete removeFromCriteria.productsubcategory;
            delete removeFromCriteria.floorLocation;
            delete removeFromCriteria.floorId;
            addToCriteria.distributor = angular.copy(this.advancedSearchFilter.distributor);
            addToCriteria.manufacturer = angular.copy(this.advancedSearchFilter.manufacturer);
            addToCriteria.productsubcategory = angular.copy(this.advancedSearchFilter.productsubcategory);
            addToCriteria.floorLocation = angular.copy(this.advancedSearchFilter.floorLocation);
            addToCriteria.floorId = this.advancedSearchFilter.floorLocation? this.advancedSearchFilter.floorLocation.id: null;
            addToCriteria["sortBy"] = this.isVariantsShown ? "Sku" : "DisplayName";

            if (this.isVariantsShown) {
                criteria.variantObjectState = [];
                criteria.includeActive = this.advancedSearchFilter.includeActive;
                criteria.includeDeleted = this.advancedSearchFilter.includeDeleted;
                criteria.productInventoryType = this.advancedSearchFilter.productInventoryType;

                if (!this.advancedSearchFilter.includeActive && !this.advancedSearchFilter.includeDeleted) {
                    this.advancedSearchFilter.includeActive = true;
                    criteria.includeActive = true;
                }

                if (!this.advancedSearchFilter["includeActiveVariant"] && !this.advancedSearchFilter.isDiscontinued ) {
                    this.advancedSearchFilter["includeActiveVariant"] = true;
                    criteria.variantObjectState.push(Meevo.Model.ObjectStateEnum.Active);
                }

                if (this.advancedSearchFilter.isDiscontinued) {
                    criteria.variantObjectState.push(Meevo.Model.ObjectStateEnum.Inactive);
                }

                if (this.advancedSearchFilter["includeActiveVariant"]) {
                    criteria.variantObjectState.push(Meevo.Model.ObjectStateEnum.Active);
                }
                criteria["IsProductBundle"] = false;
                criteria["IncludeNotForSale"] = this.advancedSearchFilter.NotForSale;
                criteria.NotForSale = null; //this.advancedSearchFilter.NotForSale ? this.advancedSearchFilter.NotForSale : null;
            } else {
                criteria.includeActive = this.advancedSearchFilter.includeActive;
                criteria.includeDeleted = this.advancedSearchFilter.includeDeleted;
                if (!criteria.includeActive && !criteria.includeDeleted) {
                    this.advancedSearchFilter.includeActive = true;
                    criteria.includeActive = true;
                }
                criteria["IsProductBundle"] = false;
                delete criteria.variantObjectState;
                delete criteria.NotForSale;
                delete criteria.isDiscontinued;
            }

            if (angular.isFunction(searchCallback)) {
                searchCallback();
            }
        }

        /**
         * Clear Advanced Search
         * @param {Function} clearAdvancedSearchFn
         */
        clearAdvancedSearch(): void {
            this.advancedSearchFilter = this.getDefaultAdvancedFilters();
        }

        /**
         * Clear field from advanced search criteria
         * @param field
         * @param {AdvancedSearchFilter} criteria
         * @param {AdvancedSearchFilter} rootCriteria
         * @param {Function} searchCallback
         * @param $event
         */
        clearField(field, criteria: AdvancedSearchFilter, rootCriteria: AdvancedSearchFilter, searchCallback: Function, $event?): void {
            if ($event) {
                $event.stopPropagation();
            }

            this.advancedSearchFilter[field] = (typeof this.advancedSearchFilter[field]) === 'boolean' ? false: undefined;
            this.preSearch(criteria, rootCriteria, searchCallback);
        }
        

        /**
         * Callback function from infinity scroll(Page Result).
         * Go through all products and create Variant name from array of variants.
         * @param {number} pageNumber
         * @param {Array<Variant>} items
         */
        getFormattedVariantName(pageNumber, items: Array<Variant>) {
            items.forEach(item => {
                if (item.variantAttributes && item.variantAttributes.length) {
                    let count = item.variantAttributes.length;

                    item['variantName'] = item.variantAttributes.reduce((accum, current, index) => {
                        return accum + current.displayName + (index == count - 1 ? '' : '|')
                    }, '')
                }
            });
        }

        public exportProductList(): void {
            this.busyService.start();
            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.product}/export`, 'GET', null)
                .then(({data}) => {
                    setTimeout(() => {
                        Meevo.Components.Common.Utilities.downloadFile(null, data, 'product-export.csv');
                    }, 1);
                })
                .finally(() => this.busyService.stop());
        }

        /**
         * On Change event handler for Product Inventory Type selection in Advanced Search
         */
        public onProductInventoryTypeChange() : void {
            if (!this.userChangedNotForSaleCheckbox) {
                this.advancedSearchFilter.NotForSale = [ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply]
                    .some(x => x == this.advancedSearchFilter.productInventoryType);
            }
        }

        /**
         * Track whether user changed Not For Sale Checkbox themselves (typescript changes it when certain Product Inventory Types are selected)
         * So we can intuitively leave it alone in onProductInventoryTypeChange if they switch back to Retail from ShopSupply
         */
        public notForSaleClicked() : void {
            this.userChangedNotForSaleCheckbox = true;
        }

        /**
         * Get Products Advanced Search default Filter values
         * @returns Object of type AdvancedSearchFilter
         */
        private getDefaultAdvancedFilters() : AdvancedSearchFilter {
            this.userChangedNotForSaleCheckbox = false;
            return this.isVariantsShown ? 
            {
                includeActive: true,
                includeActiveVariant: true,
                isDiscontinued: false,
                NotForSale: false,
                includeDeleted: false,
                productInventoryType: null
            } : 
            {
                includeActive: true,
                isDiscontinued: false,
                NotForSale: false,
                includeDeleted: false
            };
        }

        replacePipeSeperatorWithSpace = (variantName) => {
            return variantName ? variantName.replace(/[\|]/g, " ") : variantName;
        }

        changeAsLocationId = (selectedLocationType) => {
            if (selectedLocationType == 0)
                this.asLocationId = null;
        }
    }


    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.ProductController", ProductController);
}
